import {Plain} from '../../../../../../shared/model/plain.type.model';
import {EmailColumn} from './email-column.model';

/**
 * Réhydrate une colonne venue d'une source externe, et laisse passer celle qui en est déjà une.
 *
 * Une section se reconstruit à chaque retouche du contenu — changer sa couleur de fond fabrique une
 * nouvelle `EmailRow` à partir de l'ancienne. Recopier alors ses colonnes une à une les remplacerait
 * toutes par des objets neufs, alors qu'aucune n'a changé : l'éditeur ne reconnaîtrait plus ce qu'il
 * affiche d'une version du brouillon à la suivante, et le referait à chaque caractère saisi.
 */
export const toEmailColumn = (column: Plain<EmailColumn> | EmailColumn): EmailColumn =>
    column instanceof EmailColumn ? column : new EmailColumn(column);
